import i18n from '../i18n';

const MATCH_LABEL_KEYS = {
    phone: 'crossSchool:matchPhone',
    email: 'crossSchool:matchEmail',
    name: 'crossSchool:matchName'
};

function statusHint(status) {
    if (status === 'archived') return i18n.t('crossSchool:statusArchived');
    if (status === 'inactive') return i18n.t('crossSchool:statusInactive');
    return '';
}

export function formatCrossSchoolMatches(matches) {
    if (!matches?.length) return '';
    return matches
        .map(m => i18n.t('crossSchool:matchLine', {
            name: m.fullName,
            school: m.schoolName,
            reason: MATCH_LABEL_KEYS[m.matchReason]
                ? i18n.t(MATCH_LABEL_KEYS[m.matchReason])
                : m.matchReason,
            status: statusHint(m.status)
        }))
        .join('\n');
}

/**
 * POST с обработкой 409 duplicate_in_other_school: диалог и повтор с linkFrom*Id.
 * @param {import('axios').AxiosInstance} api
 * @param {string} url
 * @param {object} body
 * @param {object} params — schoolId и пр.
 * @param {{ linkParam: string, idKey: string, entityLabel: string }} options
 */
export async function postWithCrossSchoolLink(api, url, body, params, options) {
    const { linkParam, idKey, entityLabel } = options;
    try {
        return await api.post(url, body, { params });
    } catch (err) {
        const data = err.response?.data;
        if (err.response?.status >= 500) {
            const detail = data?.message || data?.title || data?.detail || err.message;
            throw new Error(i18n.t('crossSchool:serverError', {
                status: err.response.status,
                detail
            }));
        }
        if (err.response?.status !== 409 || data?.error !== 'duplicate_in_other_school') {
            throw err;
        }
        const matches = data.matches || [];
        const lines = formatCrossSchoolMatches(matches, idKey);
        const pickId = matches.length === 1
            ? matches[0][idKey]
            : null;

        let linkId = pickId;
        if (!linkId && matches.length > 1) {
            const hint = matches.map((m, i) => `${i + 1}. ${m.fullName} (${m.schoolName})`).join('\n');
            const raw = window.prompt(
                `${data.message}\n\n${lines}\n\n${i18n.t('crossSchool:pickNumberPrompt', {
                    count: matches.length,
                    hint
                })}`
            );
            const idx = parseInt(raw, 10);
            if (idx >= 1 && idx <= matches.length) linkId = matches[idx - 1][idKey];
            else return null;
        } else if (!window.confirm(
            `${data.message}\n\n${lines}\n\n${i18n.t('crossSchool:linkConfirm', { entity: entityLabel })}`
        )) {
            return null;
        }

        return await api.post(url, body, { params: { ...params, [linkParam]: linkId } });
    }
}
